import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction } from 'mobx';
import { Component } from 'react';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { SaldosReportes, SaldosReportesFormValues } from '../models/SaldosReporte';
import { CCTOperacion, CCTOperacionesFormValues } from '../models/CCTOperacion';
import { store } from './store';
import { jsPDF } from "jspdf";
import { FcPieChart } from 'react-icons/fc';

export default class SaldosReporteStore {
    SaldosRegistry = new Map<any, SaldosReportes>();


    selectedSaldos: SaldosReportes | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""
    dataMessage = false

    constructor() {
        makeAutoObservable(this)
    }

    get SaldosByCodigo() {
        return Array.from(this.SaldosRegistry.values());
    }

    get groupedSaldoss() {
        return this.SaldosRegistry
    }

    loadSaldos = async (Saldos: string) => {
        this.loadingInitial = true;
        this.dataMessage = false
        try {
            this.SaldosRegistry.clear()
            const CCTOperaciones: SaldosReportes[] =  await agent.SaldosReporte.report(Saldos);
            CCTOperaciones.forEach(element => {
                this.setSaldos(element);
            })
            this.setLoadingInitial(false);
            this.SaldosByCodigo.map((item) => {
                if( item.numeroDeRegistros== 0){
                    this.dataMessage = true
                    toast.error("No hay saldos de ese tipo de cuenta")
                }else{
                    this.dataMessage = false
                    this.reporte(this.SaldosByCodigo)
                    
                }
            })
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    private setSaldos = (data: SaldosReportes) => {
        this.SaldosRegistry.set(data.fecha, data);
    }

    private getSaldos = (Saldos: any) => {
        return this.SaldosRegistry.get(Saldos);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    reporte(SaldosReportes: any){
        let contador_paginas = 1
        let contador_lineas = 46
        const nf1 = new Intl.NumberFormat("es-MX");
        const doc = new jsPDF('p');
        doc.setFontSize(20);
        doc.text("INAP", 10, 10);
        doc.setFontSize(13);
        doc.text("Reporte de Saldos", 10, 20);
        {SaldosReportes.map((cuentas:any) =>{
            doc.text("Fecha: ", 160, 10)
            doc.text(cuentas.fecha, 175,10)
            doc.text("Hora: ", 160, 20)
            doc.text(cuentas.hora, 175,20)
            {cuentas.balancesByType.map((cuenta:any) => {
                doc.setFontSize(10);
                doc.setTextColor(9, 13, 7);
                doc.text("Tipo de Cuenta: " + cuenta.tipoDeCuenta, 10, 30)
                doc.text("DPI", 28, 40)
                doc.text("Nombre", 70, 40)
                doc.text("Descripcion", 115, 40)
                doc.text("Credito", 150, 40)
                doc.text("Debito", 170, 40)
                doc.setLineWidth(0.5); 
                doc.line(15, 42, 190, 42);
                {cuenta.balanceDetalle.map((movimiento:any) => {
                    doc.setFontSize(8);
                    doc.setTextColor(96, 96, 96 );
                    var nombre = movimiento.nombre.substr(0, 30)
                    doc.text( movimiento.dpi + "    " + nombre + "...", 20, contador_lineas)
                    var descripcion = movimiento.descripcion.substr(0,21)
                    doc.text(descripcion, 110, contador_lineas)
                    var Credito_formato = nf1.format(movimiento.credito)
                    if((movimiento.credito % 1) == 0){
                        Credito_formato = Credito_formato + ".00"
                    }
                    var Debito_formato = nf1.format(movimiento.debito)
                    if((movimiento.debito % 1) == 0){
                        Debito_formato = Debito_formato + ".00"
                    }
                    doc.text(Credito_formato, 160, contador_lineas, {align: 'right'})
                    doc.text(Debito_formato, 180, contador_lineas, {align: 'right'})
                    // doc.text(movimiento.valor, 200, contador_lineas)
                    contador_lineas = contador_lineas + 4
                    if(contador_lineas >= 292){
                        doc.addPage()
                        contador_lineas = 10
                    }
                })}
                doc.setFontSize(8);
                var totalCredito_formato = nf1.format(cuenta.totalCredito)
                if((cuenta.totalCredito % 1) == 0){
                    totalCredito_formato = totalCredito_formato + ".00"
                }
                doc.text("total " + cuenta.tipoDeCuenta + ":", 100, (contador_lineas + 6))
                doc.text(totalCredito_formato, 160, (contador_lineas + 6), {align: 'right'})
                var totalDebito_formato = nf1.format(cuenta.totalDebito)
                if((cuenta.totalDebito % 1) == 0){
                    totalDebito_formato = totalDebito_formato + ".00"
                }
                doc.text(totalDebito_formato, 180, (contador_lineas + 6), {align: 'right'})
            })}
            doc.setFontSize(10);
            doc.setTextColor(9, 13, 7);
            var total_Credito_formato = nf1.format(cuentas.saldoTotalCredito)
            if((cuentas.saldoTotalCredito % 1) == 0){
                total_Credito_formato = total_Credito_formato + ".00"
            }
            doc.text("Total:", 115, (contador_lineas + 20))
            doc.text(total_Credito_formato, 150, (contador_lineas + 20), {align: 'right'})
            var total_Debito_formato = nf1.format(cuentas.saldoTotalDebito)
            if((cuentas.saldoTotalDebito % 1) == 0){
                total_Debito_formato = total_Debito_formato + ".00"
            }
            doc.text(total_Debito_formato, 180, (contador_lineas + 20), {align: 'right'})
        })}
        // doc.text(SaldosReportes.fechaInicial, 115, 20)
        window.open(URL.createObjectURL(doc.output("blob")));
        // doc.save("REPORTE_DE_SALDOS.pdf");
    }

}